<h3 class="title">Confirm</h3>
<div class="content">{{confirmMessage}}</div>
<div class="actions">
    <button class="primary" (click)="close(false)">Cancel</button>
    <button class="warn" (click)="close(true)">Yes</button>
</div>